export enum CookieNames {
  PRIVACY_POLICY_AGREED = 'privacy-policy-agreed',
  TERMS_OF_USE_AGREED = 'terms-of-use-agreed',
}
